'use client';

import { Container, Stack, Typography, useBreakpoints } from '@castlery/fortress';
import { DYRecommendationCarousel } from '@castlery/shared-components';
import { useEffect } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import * as Sentry from '@sentry/nextjs';
// import { DYRecommendationCarousel } from '@castlery/modules-product-components';

const PageNotFoundContainer = () => {
  const { desktop } = useBreakpoints();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    // 记录404页面访问事件到Sentry
    const url = pathname + (searchParams?.toString() ? `?${searchParams.toString()}` : '');
    const referrer = typeof document !== 'undefined' ? document.referrer : '';

    Sentry.captureMessage('404 Page Not Found', {
      level: 'info', // 使用info级别，因为404是预期行为不是错误
      tags: {
        page_type: '404',
        page_category: 'not_found',
      },
      contexts: {
        page: {
          url,
          referrer,
          userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : '',
        },
      },
      extra: {
        requested_url: url,
        referrer,
        timestamp: new Date().toISOString(),
      },
    });
  }, [pathname, searchParams]);
  return (
    <Container
      sx={{
        ...(!desktop && {
          padding: '0 !important',
        }),
      }}
    >
      <Stack
        alignItems="center"
        sx={(theme) => ({
          padding: desktop ? `${theme.spacing(24)} ${theme.spacing(8)}` : `${theme.spacing(10)} ${theme.spacing(6)}`,
          backgroundColor: theme.palette.brand.warmLinen[300],
        })}
      >
        <Typography
          level="h1"
          sx={(theme) => ({ mb: desktop ? theme.spacing(10) : theme.spacing(6), textAlign: 'center' })}
        >
          This page can't be found!
        </Typography>
        <Typography level="body1" textAlign="center">
          It may have been moved, retired or updated.
        </Typography>
      </Stack>
      <DYRecommendationCarousel selector_name="LP 404 (API)" />
    </Container>
  );
};

export { PageNotFoundContainer };
